export function setOrdersLoading (state, loading = false) {
  state.ordersLoading = loading
}

export function setOrders (state, orders) {
  state.orders_cart.orders = orders.orders_cart.data
  state.orders_deviz.orders = orders.orders_deviz.data
  state.orders_cart.ordersCurrentPage = orders.orders_cart.current_page
  state.orders_deviz.ordersCurrentPage = orders.orders_deviz.current_page
  state.orders_cart.ordersLastPage = orders.orders_cart.last_page
  state.orders_deviz.ordersLastPage = orders.orders_deviz.last_page
  state.orders_cart.ordersPerPage = orders.orders_cart.per_page
  state.orders_deviz.ordersPerPage = orders.orders_deviz.per_page
  state.orders_cart.ordersTotal = orders.orders_cart.total
  state.orders_deviz.ordersTotal = orders.orders_deviz.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setComandaNR (state, comanda_nr = '') {
  state.comanda_nr = comanda_nr
}

export function setClientkey (state, clientkey = '') {
  state.clientkey = clientkey
}

export function setDatefrom (state, datefrom = '') {
  state.datefrom = datefrom
}

export function setDateto (state, dateto = '') {
  state.dateto = dateto
}
